import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

import { ApiResponse, SubscriptionParams } from './web-pushes.entity';

@Injectable({
  providedIn: 'root'
})
export class WebPushesService extends AbstractService {
  protected override prefix = '/web-pushes';

  createSubscription(params: SubscriptionParams): Observable<ApiResponse.Subscription> {
    return this.post<ApiResponse.Subscription>('/subscriptions/subscribe', params, { throwError: true });
  }

  unsubscribe(subscriptionId: string, isDenied: boolean = false): Observable<void> {
    return this.post<void>(`/subscriptions/${ subscriptionId }/unsubscribe`, { isDenied });
  }

  linkSubscriptionToUser(subscriptionId: string): Observable<void> {
    return this.post<void>(`/subscriptions/${ subscriptionId }/link-user`);
  }

  saveSubscriptionError(errorText: string): Observable<void> {
    return this.post<void>('/subscription-errors', { errorText });
  }

  trackView(pushId: number, subscriptionId: string): Observable<void> {
    return this.post<void>(`/${ pushId }/view`, { subscriptionId });
  }

  trackClick(pushId: number, subscriptionId: string, action: string): Observable<void> {
    return this.post<void>(`/${ pushId }/click`, {
      subscriptionId,
      action
    });
  }

  fetchPublicKey(): Observable<ApiResponse.PublicKey> {
    return this.get<ApiResponse.PublicKey>('/public-key');
  }
}